'use client'

import { useEffect } from 'react'

import { initializeAppInsights, trackPageView } from '@/services/appInsights'

const AppInsightsProvider = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    if (initializeAppInsights()) {
      trackPageView()
    }
  }, [])

  return <>{children}</>
}

export default AppInsightsProvider
